<template>
    <v-container>
        <v-stepper v-model="step">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1">Step 1</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2">Step 2</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 3" step="3">Step 3</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 4" step="4">Step 4</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 5" step="5">Step 5</v-stepper-step>
            </v-stepper-header>


            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-card>
                        <v-card-title>Step 1: Select Fields in Source Data for Analysis</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="4">
                                    <v-checkbox label="Administrative and billing data"
                                        v-model="formCheckboxes.admin"></v-checkbox>
                                    <v-checkbox label="Patient demographics"
                                        v-model="formCheckboxes.patientDemographics"></v-checkbox>
                                    <v-checkbox label="Progress notes" v-model="formCheckboxes.progressNotes"></v-checkbox>
                                    <v-checkbox label="Vital signs" v-model="formCheckboxes.vitalSigns"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="Medical histories"
                                        v-model="formCheckboxes.medicalHistories"></v-checkbox>
                                    <v-checkbox label="Major diagnostic category (MDC)"
                                        v-model="formCheckboxes.mdc"></v-checkbox>
                                    <v-checkbox label="Medications" v-model="formCheckboxes.medications"></v-checkbox>
                                    <v-checkbox label="Immunization dates"
                                        v-model="formCheckboxes.immunizationDates"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="Allergies" v-model="formCheckboxes.allergies"></v-checkbox>
                                    <v-checkbox label="Radiology images"
                                        v-model="formCheckboxes.radiologyImages"></v-checkbox>
                                    <v-checkbox label="Lab and test results"
                                        v-model="formCheckboxes.labResults"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="step++">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>


                <v-stepper-content step="2">
                    <v-card>
                        <v-card-title>Step 2: Select Data to be Extracted for Query (check all that apply)</v-card-title>
                        <v-card-text>
                            <h3 style="margin-bottom:1rem;">DE-IDENTIFIED PATIENT DEMOGRAPHICS</h3>
                            <v-btn @click="selectAll">SELECT ALL</v-btn>
                            <v-row>
                                <v-col cols="4">
                                    <v-checkbox label="Zip code/postal code" v-model="formCheckboxes.zip"></v-checkbox>
                                    <v-checkbox label="Age" v-model="formCheckboxes.age"></v-checkbox>
                                    <v-checkbox label="Gender at birth" v-model="formCheckboxes.gender"></v-checkbox>
                                    <v-checkbox label="Gender identity"
                                        v-model="formCheckboxes.genderIdentity"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="Race/ethnicity" v-model="formCheckboxes.race"></v-checkbox>
                                    <v-checkbox label="Household income" v-model="formCheckboxes.income"></v-checkbox>
                                    <v-checkbox label="Insurance status"
                                        v-model="formCheckboxes.insuranceStatus"></v-checkbox>
                                    <v-checkbox label="Education" v-model="formCheckboxes.education"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="Marital status" v-model="formCheckboxes.maritalStatus"></v-checkbox>
                                    <v-checkbox label="Preferred language" v-model="formCheckboxes.language"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="step--">Previous</v-btn>
                            <v-btn @click="step++">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-card>
                        <v-card-title>Step 3: Select Data to be Extracted for Query (check all that apply)</v-card-title>
                        <v-card-text>
                            <h3 style="margin-bottom:1rem;">MAJOR DIAGNOSTIC CATEGORY (MDC)</h3>
                            <v-row>
                                <v-col cols="4">
                                    <v-checkbox label="0 - Ungroupable"
                                        v-model="formCheckboxesMedicalCategories.ungroupable"></v-checkbox>
                                    <v-checkbox label="1 - Nervous System"
                                        v-model="formCheckboxesMedicalCategories.nervousSystem"></v-checkbox>
                                    <v-checkbox label="2 - Eye" v-model="formCheckboxesMedicalCategories.eye"></v-checkbox>
                                    <v-checkbox label="3 - Ear, Nose, Mouth, And Throat"
                                        v-model="formCheckboxesMedicalCategories.earNoseMouthThroat"></v-checkbox>
                                    <v-checkbox label="4 - Respiratory System"
                                        v-model="formCheckboxesMedicalCategories.respiratorySystem"></v-checkbox>
                                    <v-checkbox label="5 - Circulatory System"
                                        v-model="formCheckboxesMedicalCategories.circulatorySystem"></v-checkbox>
                                    <v-checkbox label="6 - Digestive System"
                                        v-model="formCheckboxesMedicalCategories.digestiveSystem"></v-checkbox>
                                    <v-checkbox label="7 - Hepatobiliary System and Pancreas"
                                        v-model="formCheckboxesMedicalCategories.hepatobiliarySystem"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="8 - Musculoskeletal System and Connective Tissue"
                                        v-model="formCheckboxesMedicalCategories.musculoskeletalSystem"></v-checkbox>
                                    <v-checkbox label="9 - Skin, Subcutaneous Tissue, and Breast"
                                        v-model="formCheckboxesMedicalCategories.skin"></v-checkbox>
                                    <v-checkbox label="10 - Endocrine, Nutritional, and Metabolic System"
                                        v-model="formCheckboxesMedicalCategories.endocrineSystem"></v-checkbox>
                                    <v-checkbox label="11 - Kidney and Urinary Tract"
                                        v-model="formCheckboxesMedicalCategories.kidney"></v-checkbox>
                                    <v-checkbox label="12 - Male Reproductive System"
                                        v-model="formCheckboxesMedicalCategories.maleReproductiveSystem"></v-checkbox>
                                    <v-checkbox label="13 - Female Reproductive System"
                                        v-model="formCheckboxesMedicalCategories.femaleReproductiveSystem"></v-checkbox>
                                    <v-checkbox label="14 - Pregnancy, Childbirth, and Puerperium"
                                        v-model="formCheckboxesMedicalCategories.pregnancy"></v-checkbox>
                                    <v-checkbox label="15 - Newborn and Other Neonates (Perinatal Period)"
                                        v-model="formCheckboxesMedicalCategories.newborn"></v-checkbox>
                                    <v-checkbox label="16 - Blood and Immunological Disorders"
                                        v-model="formCheckboxesMedicalCategories.bloodDisorders"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="17 - Myeloproliferative Diseases and Disorders"
                                        v-model="formCheckboxesMedicalCategories.myeloproliferative"></v-checkbox>
                                    <v-checkbox label="18 - Infectious/Parasitic Diseases and Disorders"
                                        v-model="formCheckboxesMedicalCategories.infectiousDiseases"></v-checkbox>
                                    <v-checkbox label="19 - Mental Diseases and Disorders"
                                        v-model="formCheckboxesMedicalCategories.mentalDiseases"></v-checkbox>
                                    <v-checkbox label="20 - Alcohol/Drug Use/Induced Mental Disorders"
                                        v-model="formCheckboxesMedicalCategories.alcoholDrugUse"></v-checkbox>
                                    <v-checkbox label="21 - Injuries, Poison, and Toxic Effect of Drugs"
                                        v-model="formCheckboxesMedicalCategories.injuries"></v-checkbox>
                                    <v-checkbox label="22 - Burns"
                                        v-model="formCheckboxesMedicalCategories.burns"></v-checkbox>
                                    <v-checkbox label="23 - Factors Influencing Health Status"
                                        v-model="formCheckboxesMedicalCategories.factorsInfluencingHealth"></v-checkbox>
                                    <v-checkbox label="24 - Multiple Significant Trauma"
                                        v-model="formCheckboxesMedicalCategories.multipleTrauma"></v-checkbox>
                                    <v-checkbox label="25 - Human Immunodeficiency Virus (HIV)"
                                        v-model="formCheckboxesMedicalCategories.hiv"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="step--">Previous</v-btn>
                            <v-btn @click="step++">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <v-card>
                        <v-card-title>Step 4: Select Fields to Define Report</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="4">
                                    <v-checkbox label="Birth counts" v-model="fieldCheckboxes.birth"></v-checkbox>
                                    <v-checkbox label="Birth counts by month"
                                        v-model="fieldCheckboxes.birthMonth"></v-checkbox>
                                    <v-checkbox label="Annual birth rates"
                                        v-model="fieldCheckboxes.annualBirthRates"></v-checkbox>
                                    <v-checkbox label="Birth rates by race/ethnicity"
                                        v-model="fieldCheckboxes.birthByRace"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="Death counts" v-model="fieldCheckboxes.death"></v-checkbox>
                                    <v-checkbox label="Death counts by month"
                                        v-model="fieldCheckboxes.deathMonth"></v-checkbox>
                                    <v-checkbox label="Annual death rates"
                                        v-model="fieldCheckboxes.annualDeathRates"></v-checkbox>
                                    <v-checkbox label="Death rates by race/ethnicity"
                                        v-model="fieldCheckboxes.deathByRace"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="Marital status" v-model="fieldCheckboxes.maritalStatus"></v-checkbox>
                                    <v-checkbox label="Fetal mortality"
                                        v-model="fieldCheckboxes.fetalMortality"></v-checkbox>
                                    <v-checkbox label="Infant mortality"
                                        v-model="fieldCheckboxes.infantMortality"></v-checkbox>
                                    <v-checkbox label="Population estimates"
                                        v-model="fieldCheckboxes.population"></v-checkbox>
                                    <v-checkbox label="Custom / Other Report Variables"
                                        v-model="fieldCheckboxes.custom"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="step++">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>

                <v-stepper-content step="5">
                    <v-card>
                        <v-card-title>Step 5: Review Report Request Summary</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6">
                                    <h3 style="margin-bottom:1rem;">Report Date Variables</h3>
                                    <v-checkbox label="Most Recent Complete Month"
                                        v-model="summaryCheckboxes.month"></v-checkbox>
                                    <v-checkbox label="Most Recent Complete 6-Month Period"
                                        v-model="summaryCheckboxes.sixMonth"></v-checkbox>
                                    <v-checkbox label="Most Recent Complete Annual Period"
                                        v-model="summaryCheckboxes.twelveMonth"></v-checkbox>
                                    <v-checkbox label="Legacy Dates" v-model="summaryCheckboxes.legacy"></v-checkbox>
                                    <v-checkbox label="Compare Multiple Periods"
                                        v-model="summaryCheckboxes.multiple"></v-checkbox>
                                    <v-checkbox label="Custom/Other Date Variables"
                                        v-model="summaryCheckboxes.custom"></v-checkbox>
                                </v-col>
                                <v-col cols="6">
                                    <h3 style="margin-bottom:1rem;">Sort Report Options</h3>
                                    <v-checkbox label="Household Income <$25k"
                                        v-model="fieldCheckboxes.twentyFive"></v-checkbox>
                                    <v-checkbox label="Household Income <$55k"
                                        v-model="fieldCheckboxes.fiftyFive"></v-checkbox>
                                    <v-checkbox label="Household Income >$55k"
                                        v-model="fieldCheckboxes.gFiftyFive"></v-checkbox>
                                    <v-checkbox label="Household Income >$100k"
                                        v-model="fieldCheckboxes.gHundred"></v-checkbox>
                                    <v-checkbox label="Custom/Other Sort Options"
                                        v-model="fieldCheckboxes.customSort"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="step++">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>

                <v-stepper-content step="6">
                    <v-card>
                        <v-card-title>Report Parameters</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <div class="parameter">
                                        Demographics - ALL
                                    </div>
                                    <div class="parameter">
                                        MDC - 13, 14
                                    </div>
                                    <div class="parameter">
                                        Most Recent Annual Period - {{ currentYear }}
                                    </div>
                                    <div class="parameter">
                                        Death Rates by Race/Ethnicity - {{ currentYear }}
                                    </div>
                                    <div class="parameter">
                                        Infant Mortality - {{ currentYear }}
                                    </div>
                                    <div class="parameter">
                                        Sort/Report - Income Category $25k&lt;>$55k
                                    </div>
                                    <div class="parameter">
                                        Result Statement - {{ currentYear }}
                                    </div>
                                </v-col>
                                <v-col v-if="processing && !processed">
                                    <div class="processing-step">
                                        <div v-if="processingStep === 0">
                                            PERSON_ID
                                        </div>
                                        <div v-if="processingStep === 1">
                                            GENDER_ID
                                        </div>
                                        <div v-if="processingStep === 2">
                                            YEAR_OF_BIRTH
                                        </div>
                                        <div v-if="processingStep === 3">
                                            MONTH_OF_BIRTH
                                        </div>
                                        <div v-if="processingStep === 4">
                                            DAY_OF_BIRTH
                                        </div>
                                        <div v-if="processingStep === 5">
                                            BIRTH_DATETIME
                                        </div>
                                        <div v-if="processingStep === 6">
                                            DEATH_DATETIME
                                        </div>
                                        <div v-if="processingStep === 7">
                                            RACE_CONCEPT_ID
                                        </div>
                                        <div v-if="processingStep === 8">
                                            ETHNICITY_CONCEPT_ ID
                                        </div>
                                        <div v-if="processingStep === 9">
                                            LOCATION_ID
                                        </div>
                                        <div v-if="processingStep === 10">
                                            PROVIDER_ID
                                        </div>
                                        <div v-if="processingStep === 11">
                                            CARE_SITE
                                        </div>
                                        <div v-if="processingStep === 12">
                                            PERSON_SOURCE_VALUE
                                        </div>
                                        <div v-if="processingStep === 13">
                                            GENDER_SOURCE_VALUE
                                        </div>
                                        <div v-if="processingStep === 14">
                                            GENDER_SOURCE_ CONCEPT_ID
                                        </div>
                                        <div v-if="processingStep === 15">
                                            RACE_SOURCE_ VALUE
                                        </div>
                                        <div v-if="processingStep === 16">
                                            RACE_SOURCE_ CONCEPT_ID
                                        </div>
                                        <div v-if="processingStep === 17">
                                            ETHNICITY_SOURCE_ VALUE
                                        </div>
                                        <div v-if="processingStep === 18">
                                            ETHNICITY_SOURCE_ CONCEPT_ID
                                        </div>
                                        <div v-if="processingStep === 19">
                                            PREGNANCY_CHILDBIRTH_PUERPERIUM_ID
                                        </div>
                                        <div v-if="processingStep === 20">
                                            NEWBORN_OTHER_NEONATES_ID
                                        </div>
                                        <div v-if="processingStep === 21">
                                            OBSERVATION_PERIOD TABLE
                                        </div>
                                        <div v-if="processingStep === 22">
                                            VARIABLES_SUMMARY_TABLE
                                        </div>
                                        <div v-if="processingStep === 23">
                                            BYDATE_SUMMARY_TABLE
                                        </div>
                                        <div v-if="processingStep === 24">
                                            RACE_INCOME_SUMMARY_TABLE
                                        </div>

                                        <div>
                                            <v-progress-linear :value="processingStep === 24 ? 100 : processingStep * 4"
                                                color="blue" height="10"></v-progress-linear>
                                        </div>

                                    </div>
                                    <div class="processing-head" v-if="processingStep !== 24">
                                        PROCESSING, PLEASE WAIT..........
                                    </div>
                                </v-col>
                                <v-col v-else-if="processed" class="chart-holder">
                                    <h2 style="margin-bottom: 1rem">
                                        INFANT MORTALITY RATES BY RACE AND INCOME - {{ currentYear }}
                                    </h2>
                                    <img height="250px" src="../assets/4med-chart-4.png" />
                                </v-col>
                            </v-row>

                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="step--" :disabled="processing">Previous</v-btn>
                            <v-btn @click="processReport" :disabled="processing">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-container>
</template>
  
<script>
export default {
    data() {
        return {
            step: 1,
            processingStep: 0,
            processing: false,
            processed: false,
            formData: {
                name: '',
                email: '',
                address: '',
                phone: ''
            },
            formCheckboxes: {
                zip: false,
                age: false,
                gender: false,
                genderIdentity: false,
                race: false,
                income: false,
                insuranceStatus: false,
                education: false,
                maritalStatus: false,
                language: false,
            },
            formCheckboxesMedicalCategories: {
                ungroupable: false,
                nervousSystem: false,
                eye: false,
                earNoseMouthThroat: false,
                respiratorySystem: false,
                circulatorySystem: false,
                digestiveSystem: false,
                hepatobiliarySystem: false,
                musculoskeletalSystem: false,
            },
            fieldCheckboxes: {},
            summaryCheckboxes: {}
        };
    },
    methods: {
        selectAll() {
            for (const key in this.formCheckboxes) {
                this.formCheckboxes[key] = true;
            }
        },
        async processReport() {
            this.processing = true;

            let scriptURL = "https://script.google.com/macros/s/AKfycbzQHg05TOJoMwRtfVNPHdcwZeaL1j1Mi3Xc94FflIZtrQzJwyM76rxuOfddHh-XDlLzCA/exec";
            let res = fetch(scriptURL, {
                method: "POST",
                body: JSON.stringify({
                    email: this.$store.state.learnerEmail,
                }),
            }).then(function (response) {
                response.json().then(function (results) {
                    console.log(results);
                });
            });
            console.log("res", res);

            this.processingStep = 0;
            for (let i = 0; i < 24; i++) {
                await this.sleep(Math.floor(Math.random() * 1000)); // Random delay between 0 to 1 second
                this.processingStep++;
            }
            this.processed = true;
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
    },
    computed: {
        progressBarValue() {
            return this.processingStep;
        },
        currentYear() {
            return new Date().getFullYear();
        }
    }
};
</script>
  
<style>
.processing-head {
    font-size: 1.2rem;
    font-weight: bold;
    text-align: center;
    margin-top: 1rem;
}

.email-holder {
    display: flex;
    margin-top: 2rem;
    width: 80%;
}

.chart-holder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>